import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var localPerksSpotIcon = /*#__PURE__*/React.createElement("svg", {
  height: "48",
  width: "48",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.512 13.397V7.038C5.567 6.113 13.256 3 23.614 3c10.357 0 18.046 3.113 20.1 4.038v6.359c-2.99-1.258-10.34-3.851-20.1-3.851-9.761 0-17.111 2.593-20.102 3.851m41.714 31.936h-3.664v-30.47c1.133.41 2.077.791 2.767 1.088a.995.995 0 0 0 1.385-.917V6.425a.988.988 0 0 0-.577-.905C42.9 4.504 34.399 1 23.614 1 12.828 1 4.327 4.504 2.09 5.52a.988.988 0 0 0-.578.905v8.609a.994.994 0 0 0 1.385.917 51.495 51.495 0 0 1 2.768-1.088v30.47H2a1.5 1.5 0 0 0-1.501 1.501v.499h16.713v-.502c0-.828-.671-1.498-1.498-1.498h-8.05V14.182c4.039-1.298 9.709-2.636 15.949-2.636 6.239 0 11.909 1.338 15.948 2.636v31.151h-8.05c-.827 0-1.498.67-1.498 1.498v.502h16.713v-.499c0-.829-.672-1.501-1.501-1.501",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.613 16.309c2.1 0 5.356.877 7.623 3.349 2.089 2.28 2.977 5.413 2.638 9.312-.323 3.367-2.59 6.379-4.78 9.29-2.092 2.782-4.08 5.423-4.427 8.219a.98.98 0 0 1-.98.854h-.15a.98.98 0 0 1-.977-.854c-.348-2.796-2.335-5.437-4.427-8.218-2.191-2.912-4.457-5.924-4.78-9.283-.34-3.907.549-7.04 2.638-9.32 2.267-2.472 5.523-3.35 7.622-3.35Zm0 2c-1.694 0-4.32.707-6.147 2.7-1.696 1.85-2.41 4.47-2.121 7.787.268 2.789 2.268 5.448 4.386 8.262 1.456 1.936 2.938 3.912 3.882 6.012.945-2.1 2.427-4.076 3.883-6.012 2.117-2.814 4.117-5.473 4.387-8.271.287-3.308-.426-5.928-2.122-7.778-1.827-1.993-4.453-2.7-6.148-2.7Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.776 27.513a3.162 3.162 0 1 1-6.325 0 3.162 3.162 0 0 1 6.325 0",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.451 27.513a3.162 3.162 0 1 0 6.325 0 3.162 3.162 0 0 0-6.325 0",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.451 27.513a3.162 3.162 0 1 0 6.325 0 3.162 3.162 0 0 0-6.325 0",
  fill: "#C03437"
})));

export { localPerksSpotIcon as default };
//# sourceMappingURL=localPerksSpotIcon.js.map
